import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Map } from 'immutable';
import { Observable, Subscription } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AppState } from 'src/app';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth-service.service';

@Injectable()
export class PatronService {
  private appConfiguration$: Observable<any>;
  private gbmAPI: string;
  private urlChallenge: string;
  private urlMfa: string;
  constructor(
    private store: Store<AppState>,
    private httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.appConfiguration$ = this.store.select('config');

    this.appConfiguration$
      .pipe(
        filter((mapShadowed: any) => Map.isMap(mapShadowed)),
        map((mapShadowed: any) => mapShadowed.get('api')),
        take(1),
      )
      .subscribe((api: string) => (this.gbmAPI = api));

    this.store
      .select('elPatronData')
      .pipe(
        filter((elPatronData: any) => elPatronData !== undefined),
        map((elPatronData: any) => elPatronData.toJS()),
        take(1),
      )
      .subscribe((elPatronData: any) => {
        this.urlChallenge = elPatronData.URL_CHALLENGE;
        this.urlMfa = elPatronData.URL_MFA;
      });
  }

  /**
   * Request for the user's MFA status
   *
   */
  getMFAStatus(): Observable<any> {
    return this.urlMfa !== undefined && this.httpClient.get(this.urlMfa);
  }

  /**
   * Adds the Authorizer header to api calls
   * @param validToken  - a valid token
   */
  updateAuthorizationHeader(validToken: string) {
    return this.authService.setAuthorizationSession(validToken);
  }

  /**
   * Updates read session
   * @param URL_REFRESH  - URL to be called
   * @param CLIENT_ID  - App's client id
   * @param refreshToken  - Refresh token returned by authenticator
   */
  refreshSessionElPatron(
    URL_REFRESH: string,
    CLIENT_ID: string,
    refreshToken: string,
  ): Observable<any> {
    return this.httpClient.post(`${URL_REFRESH}`, {
      refreshToken,
      clientID: CLIENT_ID,
    });
  }

  /**
   * Check if token its truthful
   * and if MFA is activated
   */
  getChallenge(): Observable<any> {
    return (
      this.urlChallenge !== undefined && this.httpClient.get(this.urlChallenge)
    );
  }

  /**
   * Tell if a token was created with mfa
   * @param URL_TOKEN_INFO  - URL to be called
   */
  getTokenInfo(URL_TOKEN_INFO: string): Observable<any> {
    return this.httpClient.get(`${URL_TOKEN_INFO}`);
  }

  /**
   * Upgrades token from read to write
   * @param URL_UPGRADE_TOKEN  - URL to be called
   * @param readToken  - Token given by el patron
   * @param code  - MFA Code from user
   */
  upgradeToken(
    URL_UPGRADE_TOKEN: string,
    readToken: string,
    code: string,
  ): Observable<any> {
    const data: any = {};

    data.grantType = 'GbmChallenge';
    data.authParameters = {
      readToken,
      code,
    };

    return this.httpClient.post(`${URL_UPGRADE_TOKEN}`, data);
  }

  /**
   * Call el patron API to delete operative session token
   * @param URL_DELETE_TOKEN - URL to be called
   * @param token - operative token
   */
  downgradeToken(URL_DELETE_TOKEN: string): Observable<any> {
    return this.httpClient.delete(`${URL_DELETE_TOKEN}`);
  }
}
